import React, { useState } from "react";
import { Pencil, PlusCircleFill } from "react-bootstrap-icons";
import "../../assets/css/style.css";
import { CardProps } from "./Card.type";
import DashboardToggle from "../../Components/FormTag/DashboardToggle";
import Pagination from "../Pagination/Pagination";
import { useNavigate, useParams } from "react-router-dom";

const CardImage: React.FC<CardProps> = ({ fields, data, header, getDetails,handleToggleChange,pagination }) => {
  const [currentPage, setCurrentPage] = useState(pagination?.currentPage ?? 1);
  const handleGetDetails = (item: any) => {
    if (getDetails) getDetails(item);
  };
   const navigation=useNavigate();
  const [status, setStatus] =useState(false);
    const handlePageChange = (page: number | ((prevState: number) => number)) => {
    if (typeof page === "number") {
      setCurrentPage(page);
      if (pagination?.onCurrentPageChange) {
        pagination.onCurrentPageChange(page);
      }
    } else {
      const newPage = page(currentPage);
      setCurrentPage(newPage);
      if (pagination?.onCurrentPageChange) {
        pagination.onCurrentPageChange(newPage);
      }
    }
  };
  const handelEditAction = (data: any) => {
    navigation(`/account/client/overview/edit/${data.id}`)
  };
  return (
    <>
      {/* Map through the data and render each item */}
      {data.map((item, index) => (
        <div
          key={index}
          className="col-lg-2 col-md-3 col-sm-6 col-xs-auto me-3 my-2 d-flex flex-column shadow grid-view-customer"
        >
          <div className="d-flex justify-content-between p-2">
            {header?.map((header, index) => (
              <div key={index} className="cursor-pointer mt-2 d-flex align-items-center text-truncate me-2" onClick={() => handleGetDetails(item)}>
                <span className="fs-15">
                  <strong>
                    {header.selector ? header.selector(item) : "N/A"}
                  </strong>
                </span>
              </div>
            ))}
            <div
              className="cursor-pointer d-flex align-items-center text-light-grey"
              onClick={() => handelEditAction(item)}
            >
              <Pencil size="16" />
            </div>
          </div>
          <div className="border-top cursor-pointer h-100 d-flex align-items-center justify-content-center" onClick={() => handleGetDetails(item)}>
            {/* Render fields dynamically based on the fields prop */}
            {fields.map((field, index) => (
              <div key={index} className="my-1 mx-2 d-flex justify-content-start align-items-center">
                {field.name ? (
                  <span>
                    <strong className="me-1 text-nowrap">{field.name}:</strong> {" "}
                  </span>
                ) : (
                  ""
                )}
                <>
                <span className="text-secondary card-img-container text-truncate d-flex align-items-center">
                  {field.selector ? field.selector(item) : "N/A"}
                </span>
                </>
              </div>
            ))}
          </div>
          <div className="border-top p-2 text-end  d-flex justify-content-end">
            <DashboardToggle className="cursor-pointer active-grid-button btn btn-info rounded-pill py-0 ps-3 pe-0" 
              defaultChecked={item.is_active === 1}
              handleToggleChange={(status: any) => handleToggleChange?.(item, status)}
            />
          </div>
          
        </div>
      ))}
      
    </>
  );
};

export default CardImage;
